const EsquemaConfiguracao = {
  GRADUACAO: 1,
  POS_GRADUACAO: 2,

  getString(id) {
    return (
      {
        1: 'Graduação',
        2: 'Pós-Graduação',
      }[id] || ''
    );
  },
};

export default EsquemaConfiguracao;
